module.exports = __webpack_public_path__ + "assets/202509252035/img/fishbone.3c81139f.png";